import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import LangTab from "../../../components/tabs/langTab";
import { showLoader } from "../../../components/loader/loader";
import { langService } from "../../../jwt/_services";
import { langPersonalTitleService } from "../../../jwt/_services/hotel/langPersonalTitleService";

class PersonalTitleLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading                 : false,
            editMode                : this.props.editMode,
            disableInputs           : this.props.disableInputs,
            personalTitle           : this.props.personalTitle,
            langChilds              : [],
            langPersonalTitelChilds : this.props.editMode ? this.props.personalTitle.langs : []
        }

        this.setForm                  = this.setForm.bind(this);
        this.combineLangChilds        = this.combineLangChilds.bind(this);
        this.getLangChilds            = this.getLangChilds.bind(this);
        this.updateParent             = this.updateParent.bind(this);
        this.getFormulary             = this.getFormulary.bind(this);

        //Handlers
        this.onNameChange             = this.onNameChange.bind(this)
    }

    componentDidMount() {
        let langChilds = [];
        this.setState({loading: true});

        // Establece las opciones de idioma
        langService.getAll().then(langOptions => {
            if (langOptions){
                langOptions.map((lang, _) => {
                    const langChild = {
                        id   : '',
                        lang : lang,
                        name : '',
                    }
                    langChilds.push(langChild);
                });
                this.setState({ langChilds, loading: false });
            }
        }).then( () => {
            if (this.state.editMode){
                langChilds = this.combineLangChilds(this.state.langChilds, this.state.langPersonalTitelChilds)
                this.setState({ langChilds })
            }
        }).finally(() => this.setState({loading: false}));
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state?.langChilds, this.state.langPersonalTitelChilds)
        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(disableInputs, langPersonalTitelChilds){
        this.setState({ disableInputs, langPersonalTitelChilds });
        this.getLangChilds();
    }

    resetForm(){
        let langOption = [];
        this.state.langChilds.map((langC) => {
            const langChild = {
                id   : '',
                lang : langC.lang,
                name : '',
            };

            langOption.push(langChild);
        });

        this.setState({langChilds: langOption, langPersonalTitelChilds: [], disableInputs : false});
        this.getLangChilds();
    }

    combineLangChilds(langOptions, langChilds) {
        try {
            if (langOptions && langChilds && langOptions.length > 0 && langChilds.length > 0) {
                langOptions.map((child, index) => {
                    const langIndex = langChilds.findIndex(n => n.lang === child.lang.id);

                    //si se encontró el lang
                    if (langIndex !== -1) {
                        langOptions[index] = {
                            id   : langChilds[langIndex].id,
                            lang : child?.lang,
                            name : langChilds[langIndex].name,
                        }
                    }
                });

                return langOptions;
            }
        } catch (e) {
            return e.message;
        }
    }

    // Le envia la información al componente padre
    updateParent(langChilds){
        this.props.updateItem(langChilds);
        this.setState({
            langChilds : langChilds,
            langPersonalTitelChilds : langChilds
        });
    }







    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    onNameChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            id   : langChilds[langIndex].id,
            lang : langChilds[langIndex].lang,
            name : value,
        }

        this.updateParent(langChilds);
    }

    getFormulary(child, index, disableInputs){
        return (
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Nombre:</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            value={ child.name }
                            onChange={ e => this.onNameChange(e.target.value, index, child.lang) }
                            disabled={ disableInputs }
                        />
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    render() {
        return (
            <Row>
                {this.state.loading ? showLoader() : null}
                <Col md="12">
                    <LangTab
                        key={"LangTabId"}
                        langChilds={this.state.langChilds}
                        getLangChilds={this.getLangChilds}
                        getFormulary={this.getFormulary}
                        disableInputs={this.state.disableInputs}
                    />
                </Col>
            </Row>
        );
    }
}

export default PersonalTitleLangs;